import activityType from './activityType';

const statuses = Object.freeze({
  STATUS_NOT_STARTED: 'not started',
  STATUS_IN_PROGRESS: 'in progress',
  STATUS_AWAITING_REVIEW: 'awaiting review',
  STATUS_READY_FOR_REVIEW: 'ready for review',
  STATUS_CAN_RETRY: 'retry',
  STATUS_FAILED: 'failed',
  STATUS_PASSED: 'passed',
  STATUS_CANCELED: 'canceled',
  STATUS_LATE_CANCELED: 'late canceled',
  STATUS_STUDENT_ABSENT: 'marked student as absent',
  STATUS_PENDING: 'pending',
  STATUS_COMPLETED: 'completed',
  STATUS_IN_ADVANCE: 'in-advance',
  STATUS_ON_TRACK_IN_ADVANCE: 'on-track-in-advance',
  STATUS_ON_TRACK_SLIGHTLY_LATE: 'on-track-slightly-late',
  STATUS_LATE: 'late',
  STATUS_CRITICALLY_LATE: 'critically-late',
  STATUS_FOLLOWED: 'followed',
  STATUS_NOT_FOLLOWED: 'not-followed',
});

export default statuses;

export const projectStatuses = [
  statuses.STATUS_NOT_STARTED,
  statuses.STATUS_IN_PROGRESS,
  statuses.STATUS_READY_FOR_REVIEW,
  statuses.STATUS_AWAITING_REVIEW,
  statuses.STATUS_FAILED,
  statuses.STATUS_PASSED,
  statuses.STATUS_CANCELED,
  statuses.STATUS_LATE_CANCELED,
  statuses.STATUS_STUDENT_ABSENT,
];

export const completionStatuses = [
  statuses.STATUS_IN_ADVANCE,
  statuses.STATUS_ON_TRACK_SLIGHTLY_LATE,
  statuses.STATUS_LATE,
  statuses.STATUS_ON_TRACK_IN_ADVANCE,
  statuses.STATUS_CRITICALLY_LATE,
];

export const sessionsStatuses = [
  statuses.STATUS_PENDING,
  statuses.STATUS_CANCELED,
  statuses.STATUS_LATE_CANCELED,
  statuses.STATUS_STUDENT_ABSENT,
  statuses.STATUS_COMPLETED,
];

export const statusesByActivity = {
  [activityType.MENTORING]: sessionsStatuses,
  [activityType.PRESENTATION]: sessionsStatuses,
};
